const jwt = require("jsonwebtoken");

function get() {
  const cookieStr = getCookie("loginsession");
  if (cookieStr) {
    return jwt.decode(cookieStr);
  }
  return null;
}
function getCookie(name) {
  var v = document.cookie.match("(^|;) ?" + name + "=([^;]*)(;|$)");
  return v ? v[2] : null;
}

var session = { contents: get() };
window.setInterval(function() {
  session.contents = get();
}, 1000);

export default session;



// WEBPACK FOOTER //
// ./src/lib/session.js